"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.nftProjects = void 0;
exports.nftProjects = [
    {
        name: "3Landers",
        address: "0xb4d06d46A8285F4EC79Fd294F78a881799d8cEd9",
    },
    {
        name: "8Liens",
        address: "0x740c178e10662bBb050BDE257bFA318dEfE3cabC",
    },
    {
        name: "AlienFrens",
        address: "0x123b30E25973FeCd8354dd5f41Cc45A3065eF88C",
    },
    {
        name: "Azuki",
        address: "0xED5AF388653567Af2F388E6224dC7C4b3241C544",
    },
    {
        name: "BoredApeKennelClub",
        address: "0xba30E5F9Bb24caa003E9f2f0497Ad287FDF95623",
    },
    {
        name: "BoredApes",
        address: "0xbc4ca0eda7647a8ab7c2061c2e118a18a936f13d",
    },
    {
        name: "ChainRunners",
        address: "0x97597002980134bea46250aa0510c9b90d87a587",
    },
    {
        name: "CoolCats",
        address: "0x1a92f7381b9f03921564a437210bb9396471050c",
    },
    {
        name: "CrypToads",
        address: "0x1cb1a5e65610aeff2551a50f76a87a7d3fb649c6",
    },
    {
        name: "CryptoMories",
        address: "0x1a2F71468F656E97c2F86541E57189F59951efe7",
    },
    {
        name: "CyberKongs",
        address: "0x57a204AA1042f6E66DD7730813f4024114d74f37",
    },
    {
        name: "DeadFellas",
        address: "0x2acAb3DEa77832C09420663b0E1cB386031bA17B",
    },
    {
        name: "GutterCatGang",
        address: "0xEdB61f74B0d09B2558F1eeb79B247c1F363Ae452",
    },
    {
        name: "LazyLions",
        address: "0x8943c7bac1914c9a7aba750bf2b6b09fd21037e0",
    },
    {
        name: "Mfers",
        address: "0x79fcdef22feed20eddacbb2587640e45491b757f",
    },
    {
        name: "Moonbirds",
        address: "0x23581767a106ae21c074b2276D25e5C3e136a68b",
    },
    {
        name: "MutantApeYachtClub",
        address: "0x60E4d786628Fea6478F785A6d7e704777c86a7c6",
    },
    {
        name: "WorldOfWomen",
        address: "0xe785e82358879f061bc3dcac6f0444462d4b5330",
    },
    {
        name: "CryptoPunks",
        address: "0xb47e3cd837ddf8e4c57f05d70ab865de6e193bbb",
    },
    {
        name: "HaleyBros",
        address: "0x3ed0814bE6C0679A89Ca6Ed323E475ca66a73743",
    },
];
//# sourceMappingURL=nftProjects.js.map